import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { BuisnessPromotion, ServiceList } from 'src/app/models/common';
import { ApiService } from 'src/app/providers/api.service';
import { FormControl } from '@angular/forms';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from 'src/app/providers/shared.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';

@Component({
  selector: 'sm-add-new-template-service-for-business',
  templateUrl: './add-new-template-service-for-business.component.html',
  styleUrls: ['./add-new-template-service-for-business.component.scss']
})
export class AddNewTemplateServiceForBusinessComponent implements OnInit, OnDestroy {
  taxSlabData:any = []
    selectedSlab:any = 'default'
    isEntityForeign: string = localStorage.getItem(SM_CONSTANTS.IS_ENTITY_FOREIGN)!
    isTaxApplicable: boolean = false
      isOnlineAvailable: boolean = false

  home_status: any = sessionStorage.getItem('home_service_status')
  shop_status: any = sessionStorage.getItem('shop_service_status')
  virtual_status: any = sessionStorage.getItem('virtual_service_status')
  isDiscountApplicable: boolean = false
  public serviceListData: ServiceList = new ServiceList();
  isDiscount!: boolean;
  isShop: boolean = false
  isHome: boolean = false
  isVirtual: boolean = false
  isPercent!: boolean
  isAmount!: boolean
  isHomeSpecific: Boolean = false;
  isShopSpecific: Boolean = false;
  isVirtualSpecific: Boolean = false;
  entityHash: string = '';
  hideRequiredControl = new FormControl(false);
  public fileName: string = '';
  private _apiSubscription: Subscription = new Subscription();
  public editMode: boolean = false;
  public loader: boolean = false;
  public removable: boolean = true;
  public assetList: any[] = [];
  public page: number = 1;
  serviceList: any[] = [];
  selectedserviceList: any[] = [];
  datalength!: number
  toShowTemplate: boolean = true
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private loaderservice: LoaderServiceService,
    private router: Router,
    public dialog: MatDialogRef<AddNewTemplateServiceForBusinessComponent>
  ) {}
  removeAsset() {
    this.serviceListData.imgUrl = '';
    this.assetList = [];
  }
  priceCheker() {
    if (this.isHomeSpecific && (this.serviceListData.home_rate == null || this.serviceListData.home_rate < 0)) {
      return true;
    } else if (this.isShopSpecific && (this.serviceListData.shop_rate == null || this.serviceListData.shop_rate < 0)) {
      return true;
    } else if (this.isVirtualSpecific && (this.serviceListData.virtualRate == null || this.serviceListData.virtualRate < 0)) {
      return true;
    } else if (!this.isHomeSpecific && !this.isShopSpecific && !this.isVirtualSpecific) {
      return true;
    } else {
      return false;
    }
  }
  discountChecker(){
    console.log();
    
    if(this.isDiscountApplicable){
      
      if(!this.serviceListData.discountType || !this.serviceListData.discountAmount){
        return true
      }else{
        return false
      }
    }else{
      return false
    }
  }
  ngOnInit(): void {

    this.serviceListData.discountStatus = 0
    // this._apiService.getServiceTemplates(this.page);
  this._apiService.getServiceTemplateDataByKeyword(
      this.page,
      this.searchString.value ?? ""
    );
        console.log(this.isDiscount);
    console.log(this.isPercent);
    
    
    console.log(this.parentData.data);
    this.entityHash = this.parentData.entityHash

    let data: any = new ServiceList();
    Object.assign(data, this.parentData.data);
    console.log(data);
    if (data.hash_id) {

      if(data.imgUrl && data.imgUrl != 'null'){
        this.assetList.push({
          assetName: data?.imgUrl
            .split('/')
            .pop()
            .substring(data.imgUrl.split('/').pop().lastIndexOf('_') + 1),
          url: data?.imgUrl,
        });
      }
      this.assetList.push({
        assetName: data?.imgUrl
          .split('/')
          .pop()
          .substring(data.imgUrl.split('/').pop().lastIndexOf('_') + 1),
        url: data?.imgUrl,
      });
      this.serviceListData = data;
      this.editMode = true;
    }
    if(data.shopStatus == 1){
      this.isShop = true
      let eve = {
        checked: true,
        source: {
          value: 'shop'
        }
      }
      this.change(eve);
    }
    if(data.homeStatus == 1){
      this.isHome = true
      let eve = {
        checked: true,
        source: {
          value: 'home'
        }
      }
      this.change(eve);
    }
    if(data.for_virtual == 1){
      this.isVirtual = true
      let eve = {
        checked: true,
        source: {
          value: 'virtual'
        }
      }
      this.change(eve);
    }
    if(data.discountStatus ==1){
      this.isDiscount = true
    }
    if(data.discountStatus == 0 ){
      this.isDiscount = false
    } 
    if(data.discountType == 2 ){
      this.isAmount = true
    }
    if(data.discountType == 1 ){
      this.isPercent = true
    }

    
    this._apiSubscription = this._apiService.apiResult.subscribe((res) => {
      console.log('Response', res);
      if (res.responseType === SM_CONSTANTS.UPLOAD_RESULT) {
        console.log(res.result);
        this.assetList.push({
          assetName: this.fileName,
          url: res.result?.url,
          thumbnail: res.result?.thumbnail,
        });
        this.serviceListData.imgUrl = res.result?.url;
        this.loader = false;
      }
      if(res.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_TAX_SLAB_DATA){
        this.taxSlabData = []
        if(res.result){
          if(!this.editMode){
            this.taxSlabData = res.result.filter((item:any) => item.tax_collection_status == 1)
            this.isTaxApplicable = true
            this.serviceListData.tax_collecion_status = 1
            this.serviceListData.tax_collection_status = 1
            this.loaderservice.showLoader = false

          }
          else{
            this.taxSlabData = res.result.filter((item:any) => item.tax_collection_status == 1)
            let selectedTaxSlab = this.taxSlabData.filter((item:any) => item.hash_id == this.serviceListData.tax_slab_hash)
            this.isTaxApplicable = true
            this.serviceListData.tax_collecion_status = 1
            this.serviceListData.tax_collection_status = 1
            this.selectedSlab = selectedTaxSlab[0] ? selectedTaxSlab[0] : 'default'
            this.loaderservice.showLoader = false
          }
        }
        else{
          this.isTaxApplicable = true
          this.loaderservice.showLoader = false
        }
      }
      if(res.responseType === SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_TAX_SLAB_DATA){
        this.taxSlabData = []
        if(res.result){
         if(!this.editMode){
          this.taxSlabData = res.result.filter((item:any) => item.tax_collection_status == 1)
            this.isTaxApplicable = true
            this.serviceListData.tax_collecion_status = 1
            this.serviceListData.tax_collection_status = 1
            this.loaderservice.showLoader = false

          }
          else{
            this.taxSlabData = res.result.filter((item:any) => item.tax_collection_status == 1)
            let selectedTaxSlab = this.taxSlabData.filter((item:any) => item.hash_id == this.serviceListData.tax_slab_hash)
            this.isTaxApplicable = true
            this.serviceListData.tax_collecion_status = 1
            this.serviceListData.tax_collection_status = 1
            this.selectedSlab = selectedTaxSlab[0] ? selectedTaxSlab[0].hash_id : 'default'
            this.loaderservice.showLoader = false
          }
        }
        else{
          this.isTaxApplicable = true
          this.loaderservice.showLoader = false
        }
      }
      if(res.responseType === SM_CONSTANTS.GET_SERVICE_TEMPLATES_RESULT){
       

        // this.serviceList = []
        console.log(res);
       if(res.result){
        this.datalength = res.result[0].totalCount
        res.result.forEach((element:any) => {
          element.selected = false
          this.serviceList.push(element)
        });
       }
       else{
        this.datalength = 0
       }
        
        
      }
      else if(res.responseType === SM_CONSTANTS.ADD_UPDATE_SERVICE_TYPE_RESULT){
        if(res.result && res.result != null){
          this.dialog.close({msg:'success'})
        }
      }
      if(res.responseType === SM_CONSTANTS.RESULT_API_GET_SERVICE_TEMPLATE_DATA_BY_KEYWORD){
       

        // this.serviceList = []
        console.log(res);
       if(res.result){
        this.datalength = res.result[0].totalCount
        res.result.forEach((element:any) => {
          element.selected = false
          this.serviceList.push(element)
        });
       }
       else{
        this.datalength = 0
       }
        
        
      }
    });
  }
  change(event:any){
    console.log(event);
    if(event.checked == true && event.source.value == 'home'){
      this.isHomeSpecific = true
      this.serviceListData.homeStatus = 1
    } if(event.checked == true && event.source.value == 'shop'){
      this.isShopSpecific = true
      this.serviceListData.shopStatus = 1
    } 
    if(event.checked == true && event.source.value == 'virtual'){
      this.isVirtualSpecific = true
      this.serviceListData.for_virtual = 1
      this.serviceListData.virtualStatus = 1
    } 
    
    if(event.checked == false && event.source.value == 'home'){
      this.isHomeSpecific = false
      this.serviceListData.homeStatus = 0
      this.serviceListData.home_rate = null
      this.serviceListData.homeDiscountedPrice = null
    }if(event.checked == false && event.source.value == 'shop'){
      this.isShopSpecific = false
      this.serviceListData.shopStatus = 0
      this.serviceListData.shop_rate = null
      this.serviceListData.shopDiscountedPrice = null
    }
    if(event.checked == false && event.source.value == 'virtual'){
      this.isVirtualSpecific = false
      this.serviceListData.for_virtual = 0
      this.serviceListData.virtualStatus = 0
      this.serviceListData.virtualRate = null
      this.serviceListData.virtual_rate = null
      this.serviceListData.virtualDiscountedPrice = 0
      this.serviceListData.virtual_discounted_amount = null
      
    }
    
  }

  onApp(event:any){

    if(event.target.value == 'applicable' ){
      this.serviceListData.discountStatus = 1
    }if(event.target.value == 'not-applicable'){
      this.serviceListData.discountStatus = 0
      this.serviceListData.discountAmount = null
      this.serviceListData.discountType = null
      this.isPercent = false
      this.isAmount = false
      this.serviceListData.homeDiscountedPrice = null
      this.serviceListData.shopDiscountedPrice = null
      this.serviceListData.virtualDiscountedPrice = 0
      this.serviceListData.virtual_discounted_amount = null
    }

  }

  discType(event:any){
    if(event.target.value == 'percent' ){
      this.serviceListData.discountType = 1
    }if(event.target.value == 'amount'){
      this.serviceListData.discountType = 2
    }

  }

  ngOnDestroy() {
    this._apiSubscription.unsubscribe();
           this.serviceList = []
           this.page = 1
  }

  onPost() {
    // console.log('Data', this.serviceListData);
 
    console.log(this.editMode);
    if (!this.editMode) {
      // this.serviceListData['hash_id'] = undefined;
    }

    if(this.serviceListData.discountType == 1){
      if(this.serviceListData.homeStatus != 0){
        this.serviceListData.homeDiscountedPrice = +(this.serviceListData.home_rate - (this.serviceListData.discountAmount/100)*this.serviceListData.home_rate).toFixed(2)
      }
      if(this.serviceListData.shopStatus != 0){
        this.serviceListData.shopDiscountedPrice = +(this.serviceListData.shop_rate - (this.serviceListData.discountAmount/100)*this.serviceListData.shop_rate).toFixed(2)
      }
      if(this.serviceListData.virtualStatus != 0 && this.serviceListData.for_virtual != 0){
        this.serviceListData.virtualDiscountedPrice = this.serviceListData.virtualRate - (this.serviceListData.discountAmount/100)*this.serviceListData.virtualRate
      }
      
    }else if(this.serviceListData.discountType == 2){
      if(this.serviceListData.homeStatus != 0){
        this.serviceListData.homeDiscountedPrice = this.serviceListData.home_rate - this.serviceListData.discountAmount
      }
      if(this.serviceListData.shopStatus != 0){
        this.serviceListData.shopDiscountedPrice = this.serviceListData.shop_rate - this.serviceListData.discountAmount
      }
      if(this.serviceListData.virtualStatus != 0){
        this.serviceListData.virtualDiscountedPrice = this.serviceListData.virtualRate - this.serviceListData.discountAmount
      }
     
    }

    if(this.serviceListData.homeStatus == 0){
      this.serviceListData.home_rate = 0
    }
    
    if(this.serviceListData.shopStatus == 0){
      this.serviceListData.shop_rate = 0
    }
    if(this.serviceListData.virtualStatus == 0){
      this.serviceListData.virtualRate = 0
    }
    if(this.serviceListData.discountStatus == 0 || this.serviceListData.discountStatus == null){
      this.serviceListData.discountStatus == 0
      this.serviceListData.discountAmount = 0
      this.serviceListData.homeDiscountedPrice = 0
      this.serviceListData.shopDiscountedPrice = 0
      this.serviceListData.virtualDiscountedPrice = 0
    }

    if(this.serviceListData.home_rate == '-'){
      this.serviceListData.home_rate = 0
    }
    if(this.serviceListData.shop_rate == '-'){
      this.serviceListData.shop_rate = 0
    }
    if(this.serviceListData.virtual_rate == '-'){
      this.serviceListData.virtualRate = 0
    }
    if(this.serviceListData.homeDiscountedPrice == '-'){
      this.serviceListData.homeDiscountedPrice = 0
    }
    if(this.serviceListData.shopDiscountedPrice == '-'){
      this.serviceListData.shopDiscountedPrice = 0
    }
    if(this.serviceListData.virtualDiscountedPrice == '-'){
      this.serviceListData.virtualDiscountedPrice = 0
    }
    this.serviceListData.tax_slab_hash = this.selectedSlab == 'default' ? null : this.selectedSlab
    this.serviceListData.is_available_online = this.isOnlineAvailable == true ? 1 : 0
    Object.keys(this.serviceListData).forEach(key => {
      if ((this.serviceListData as any)[key] === null) {
        delete (this.serviceListData as any)[key];
      }
    });
  
 let bodydata = {
  serviceTypeInfo: this.serviceListData
 }
    console.log('updated data', bodydata);
    this.loaderservice.showLoader = true
    this._apiService.addUpdateServiceType(bodydata, this.entityHash)
    // this.dialog.close();
    //   setTimeout(() => {
    //     this.sharedService.sendClickEvent();
    //   }, 2000);
    // this._apiService.updateBuisnessPromotion({
    //   promotionInfo: this.serviceListData,
    // });
  }

  onUploadImage(event: any) {
    this.loader = true;
    console.log(event.target.files);
    if (event.target.value === '') {
      this.loader = false;
      return;
    }
    this.fileName = event.target.files[0].name;
    let sizeinKb = +event.target.files[0].size / 1000;
    if (sizeinKb > 1021) {
      this._snackBar.open('Image size should not exceed more then 1 mb', 'Ok');
      return;
    }
    let formData: FormData = new FormData();
    formData.append('recfile', event.target.files[0]);
    this._apiService.uploadAssets(formData, 1);
  }

  selectInventoryTemplate(item:any){
    this.selectedserviceList = []
    this.serviceList.forEach((element:any) => {
      element.selected = false
    });
    item.selected = true

    this.selectedserviceList.push(item)

  }

  onSelectNext(){
    this.toShowTemplate = false

    this.serviceListData.serviceName = this.selectedserviceList[0].serviceName
    this.serviceListData.description = this.selectedserviceList[0].description
    this.serviceListData.approxTime = this.selectedserviceList[0].approxTime
    this.serviceListData.imgUrl =  this.selectedserviceList[0].imgUrl

    this.assetList = []
    if(this.selectedserviceList[0].imgUrl && this.selectedserviceList[0].imgUrl != 'null'){
      this.assetList.push({
        assetName: this.selectedserviceList[0]?.imgUrl
          .split('/')
          .pop()
          .substring(this.selectedserviceList[0].imgUrl.split('/').pop().lastIndexOf('_') + 1),
        url: this.selectedserviceList[0]?.imgUrl,
      });
    }

  }

  back(){
    this.toShowTemplate=true

   
  }

  seeMore(){
    this.page +=  1;
    // this._apiService.getServiceTemplates(this.page)
      this._apiService.getServiceTemplateDataByKeyword(
      this.page,
      this.searchString.value ?? ""
    );
  }

  onPageChange(ev: any) {
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;
    // this._apiService.getServiceTemplates(this.page)
      this._apiService.getServiceTemplateDataByKeyword(
      this.page,
      this.searchString.value ?? ""
    );
  }

  onToggleChange(event: any){
    
    if(event.checked){
      this.isDiscountApplicable = true
      this.serviceListData.discountStatus = 1
    }
    else if(!event.checked){
      this.isDiscountApplicable = false
      this.serviceListData.discountStatus = 0
      this.serviceListData.discountAmount = null
      this.serviceListData.discountType = null
      this.isPercent = false
      this.isAmount = false
      this.serviceListData.homeDiscountedPrice = null
      this.serviceListData.shopDiscountedPrice = null
    }
  }

  onToggleChangeForTax(event: any){
    this.selectedSlab = 'default'
    if(event.checked){
      this.loaderservice.showLoader = true
      if(this.isEntityForeign == '0'){
        this._apiService.getEntityTaxSlabData(this.entityHash)
      }
      else if(this.isEntityForeign == '1'){
        this._apiService.getInternationalEntityTaxSlabsData(this.entityHash)
      }
    
    }
    else if(!event.checked){
      this.isTaxApplicable = false
      this.serviceListData.tax_collecion_status = 0
      this.serviceListData.tax_collection_status = 0
      this.serviceListData.tax_slab_hash = null
    }
  }

  configureTax(){
    this.dialog.close()
    this.router.navigate(['/businesses/details/tax-and-gst'],{queryParams: {entityHash: this.entityHash}})
  }

  searchString: FormControl = new FormControl('');
  firstTimeBelow3:boolean = false;

  debounceTimer: any;  // Declare this at the class level

searchServiceData() {
  clearTimeout(this.debounceTimer);  // Clear previous timer

  this.debounceTimer = setTimeout(() => {
    const value = this.searchString?.value ?? '';

    if (value.length >= 3) {
      console.log('holfirst');
      this.serviceList = [];
      this.firstTimeBelow3 = true;
      this.page = 1;
      this._apiService.getServiceTemplateDataByKeyword(this.page, value);
    } else {
      if (this.firstTimeBelow3) {
        console.log('holsecond');
        this.serviceList = [];
        this.firstTimeBelow3 = false;
        this.page = 1;
        // this._apiService.getServiceTemplates(this.page);
          this._apiService.getServiceTemplateDataByKeyword(
      this.page,
      ""
    );
      }
    }
  }, 300); // Delay in ms
}

  reset(){
    this.serviceList = []
    this.searchString.reset()
    this.page = 1
    // this._apiService.getServiceTemplates(this.page);
      this._apiService.getServiceTemplateDataByKeyword(
      this.page,
       ""
    );

  }

   onToggleChangeForOnline(event: any){
    
      console.log(event);
    if(event.checked){
      this.isOnlineAvailable = true
    
    }
    else if(!event.checked){
      this.isOnlineAvailable = false
    }
      
  }

}
